import _extends from "@babel/runtime-corejs3/helpers/extends";
import { noop as _$no, createElementVNode as _$ce, createUnknownComponentVNode as _$cc, className as _$cn, extend as _$ex, EMPTY_OBJ as _$em, createVNode as _$cv, map as _$ma } from 'intact-vue-next';
import { linkEvent } from 'intact-vue-next';
import { Spinner } from '../spinner';
import { Tooltip } from '../tooltip';
import { getRestProps } from '../utils';
import { makeStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    disabled = _this$get.disabled,
    className = _this$get.className,
    max = _this$get.max,
    min = _this$get.min,
    unit = _this$get.unit,
    showInput = _this$get.showInput,
    range = _this$get.range,
    step = _this$get.step,
    value = _this$get.value,
    spinnerProps = _this$get.spinnerProps,
    showEnd = _this$get.showEnd,
    showTooltip = _this$get.showTooltip,
    animate = _this$get.animate,
    forceStep = _this$get.forceStep;
  var _this$draggable = this.draggable,
    onStart = _this$draggable.onStart,
    trackRef = _this$draggable.trackRef,
    dragging = _this$draggable.dragging,
    firstThumbRef = _this$draggable.firstThumbRef,
    secondThumbRef = _this$draggable.secondThumbRef,
    onFocusin = _this$draggable.onFocusin;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-slider"] = true, _classNameObj[k + "-disabled"] = disabled, _classNameObj[k + "-dragging"] = dragging.value || !animate, _classNameObj[className] = className, _classNameObj[makeStyles(k)] = true, _classNameObj);
  var _this$styles = this.styles(),
    barStyle = _this$styles.barStyle,
    thumbFirstStyle = _this$styles.thumbFirstStyle,
    thumbSecondStyle = _this$styles.thumbSecondStyle;
  var _this$value = this.value,
    onSpinnerChange = _this$value.onSpinnerChange,
    onLeftSpinnerChange = _this$value.onLeftSpinnerChange,
    onRightSpinnerChange = _this$value.onRightSpinnerChange;
  var _this$keyboard = this.keyboard,
    onKeydown = _this$keyboard.onKeydown,
    onKeyup = _this$keyboard.onKeyup;
  var _this$tooltip = this.tooltip,
    firstTooltipRef = _this$tooltip.firstTooltipRef,
    secondTooltipRef = _this$tooltip.secondTooltipRef,
    getTooltipProps = _this$tooltip.getTooltipProps,
    hide = _this$tooltip.hide;
  var tooltipProps = getTooltipProps();
  var tooltip = function tooltip(value) {
    return _$blocks['tooltip'] = function ($super) {
      return value;
    }, __$blocks['tooltip'] = function ($super, data) {
      var block = $blocks['tooltip'];
      var callBlock = function callBlock() {
        return _$blocks['tooltip'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }, __$blocks['tooltip'](_$no, value);
  };
  var createThumb = function createThumb(thumbStyle, isFirst, ref, value, tooltipRef) {
    return _$ce(2, 'div', _$cc(Tooltip, _extends({
      'disabled': !showTooltip,
      'ref': tooltipRef
    }, tooltipProps, {
      'className': _$cn(k + "-slider-tooltip"),
      'children': _$ce(2, 'div', null, 1, _$cn(k + "-slider-thumb"), {
        'tabindex': disabled ? '-1' : '0',
        'ev-mousedown': onStart,
        'ev-focusin': linkEvent(isFirst, onFocusin),
        'ev-focusout': hide,
        'ev-keydown': onKeydown,
        'ev-keyup': onKeyup
      }, null, ref),
      '$blocks': function ($blocks) {
        var _$blocks = {},
          __$blocks = _$ex({}, $blocks);
        return (_$blocks['content'] = function ($super) {
          return tooltip(value);
        }, __$blocks['content'] = function ($super, data) {
          var block = $blocks['content'];
          var callBlock = function callBlock() {
            return _$blocks['content'].call($this, $super, data);
          };
          return block ? block.call($this, callBlock, data) : callBlock();
        }), __$blocks;
      }.call($this, _$em)
    }), null, tooltipRef), 2, _$cn(k + "-slider-thumb-wrapper"), {
      'style': thumbStyle
    });
  };
  var _this$click = this.click,
    onClickTrack = _this$click.onClickTrack,
    setOneValue = _this$click.setOneValue;
  var points = this.points();
  var marks = this.marks();
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), [_$ce(2, 'div', [_$ce(2, 'div', _$ce(2, 'div', [_$ce(2, 'div', null, 1, _$cn(k + "-slider-bar"), {
    'style': barStyle
  }), createThumb(thumbFirstStyle, true, firstThumbRef, range ? value[0] : value, firstTooltipRef), range ? createThumb(thumbSecondStyle, false, secondThumbRef, value[1], secondTooltipRef) : undefined, _$ma(points, function ($value, $key) {
    var _$cn2;
    return _$ce(2, 'i', null, 1, _$cn((_$cn2 = {}, _$cn2[k + "-slider-point"] = true, _$cn2[k + "-active"] = $value.active, _$cn2)), {
      'style': $value.style
    });
  }, $this)], 0, _$cn(k + "-slider-track"), null, null, trackRef), 2, _$cn(k + "-slider-track-wrapper"), {
    'ev-click': onClickTrack
  }), marks.length ? _$ce(2, 'div', _$ma(marks, function ($value, $key) {
    var _$cn3;
    return _$ce(2, 'span', $value.text, 0, _$cn((_$cn3 = {}, _$cn3[k + "-active"] = $value.active, _$cn3)), {
      'style': $value.style,
      'ev-click': linkEvent($value.value, setOneValue)
    });
  }, $this), 4, _$cn(k + "-slider-marks")) : showEnd ? _$ce(2, 'div', [_$ce(2, 'span', min + unit, 0, null, {
    'ev-click': linkEvent(min, setOneValue)
  }), _$ce(2, 'span', max + unit, 0, null, {
    'ev-click': linkEvent(max, setOneValue)
  })], 4, _$cn(k + "-slider-ends")) : undefined], 0, _$cn(k + "-slider-main")), showInput ? _$ce(2, 'div', function () {
    var props = {
      disabled: disabled,
      min: min,
      max: max,
      step: step || 0.01,
      vertical: true,
      suffix: unit,
      forceStep: !!step && forceStep
    };
    return [_$cc(Spinner, _extends({}, props, {
      'value': range ? value[0] : value,
      'ev-$change:value': range ? onLeftSpinnerChange : onSpinnerChange
    }, spinnerProps)), range ? [_$ce(2, 'span', '-', 16, _$cn(k + "-slider-spinner-sep")), _$cc(Spinner, _extends({}, props, {
      'min': value[0],
      'value': range ? value[1] : value,
      'ev-$change:value': onRightSpinnerChange
    }, spinnerProps))] : undefined];
  }(), 0, _$cn(k + "-slider-spinner")) : undefined]);
}
;